import { getTrashNotesListState, getTrashNotesState } from '@/reducers/Trash/TrashNotesReducer';
import { put, call, takeLatest, select, takeEvery, take } from 'redux-saga/effects';
import { CONTENT_NOT_FOUND } from '../constants/variables';
import { Notebooks, Notes, Trash } from '../constants/actionTypes';
import ajax from '../utils/ajax';

function* getTrashNotesListAsync(action) {
  const { isForce } = action;
  const trashNotesListState = yield select(getTrashNotesListState);
  const seq = trashNotesListState.get('seq');
  let newData;
  try {
    if (!seq || isForce) {
      const { data } = yield call(ajax.getTrashNotesList);
      newData = data;
    }
    yield put({ type: Trash.GET_TRASH_NOTES_LIST_SUCCESS, data: newData });
  } catch (e) {
    yield put({ type: Trash.GET_TRASH_NOTES_LIST_FAIL });
  }
}

function* getTrashNoteContentAsync(action) {
  const { isForce, noteId } = action;
  const trashNotes = yield select(getTrashNotesState);
  // 必须获取content字段，只获取noteId一级在reducer里GET_TRASH_NOTE_CONTENT时已经设置了
  let note;
  const noteContent = trashNotes.getIn([noteId, 'content'], CONTENT_NOT_FOUND);
  try {
    if (noteContent === CONTENT_NOT_FOUND || isForce) {
      const { data } = yield call(ajax.getNoteContent, noteId);
      note = data;
    }
    yield put({ type: Trash.GET_TRASH_NOTE_CONTENT_SUCCESS, data: note, noteId });
  } catch (e) {
    yield put({ type: Trash.GET_TRASH_NOTE_CONTENT_FAIL, noteId });
  }
}

function* delTrashNote(action) {
  const { noteId, doneCallback } = action;
  try {
    const { data } = yield call(ajax.deleteNote, noteId);
    doneCallback(null, { noteId });
    yield put({ type: Trash.DEL_TRASH_NOTE_SUCCESS, data, noteId });
  } catch (e) {
    yield put({ type: Trash.DEL_TRASH_NOTE_FAIL, noteId });
    doneCallback(e.error);
  }
}

// 恢复文章
function* recoveryTrashNote(action) {
  const { noteId, doneCallback } = action;
  try {
    const { data } = yield call(ajax.recoveryNote, noteId);
    const nbId = data.notebook_id;
    // 恢复文章后需要强制更新文集数据，其实应该只需要更新文章所在的文集的数据，但目前还木有这种接口
    // 更新文章数据
    yield put({ type: Trash.RECOVERY_TRASH_NOTE_SUCCESS, data, noteId });
    doneCallback(null, { nbId, noteId });
    yield put({ type: Notebooks.GET_NOTEBOOKS, isForce: true });
    yield put({ type: Notes.GET_NOTES, isForce: true, nbId });
  } catch (e) {
    yield put({ type: Trash.RECOVERY_TRASH_NOTE_FAIL, noteId });
    doneCallback(e);
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* watchGetTrashNotesList() {
  yield takeLatest(Trash.GET_TRASH_NOTES_LIST, getTrashNotesListAsync);
}

export function* watchGetTrashNote() {
  yield takeLatest(Trash.GET_TRASH_NOTE_CONTENT, getTrashNoteContentAsync);
}

export function* watchDelTrashNote() {
  yield takeLatest(Trash.DEL_TRASH_NOTE, delTrashNote);
}

export function* watchRecoveryTrashNote() {
  yield takeLatest(Trash.RECOVERY_TRASH_NOTE, recoveryTrashNote);
}



// WEBPACK FOOTER //
// ./src/sagas/TrashSaga.js